import React, { useCallback, useEffect, useRef, useState } from 'react'
import AllProductsStyle from '../../AllProducts/AllProducts'
import Button from '../../../components/Button'
import api from '../../../api'
import { get, set } from 'lodash'
import Layout from '../../../components/Layout'
import { ErrorModal } from '../../../components/Modal'
import ClipLoader from 'react-spinners/ClipLoader'
import { isAxiosError } from 'axios'
import _ from 'lodash'
import { useSelector } from 'react-redux'
import { BG_COLOR } from '../../../constants/colors'
import CreateBlackListUser from '../../../components/Modal/BlackListModal/AddBlackListClientsModal'

export default function BlackListClients() {
	const { getMe } = useSelector((state) => state.main)
	const role = getMe?.Department2?.Name
	const errorRef = useRef()
	const [searchValue, setSearchValue] = useState('')
	const [isLoading, setIsLoading] = useState(false)
	const [data, setData] = useState([])
	const [isAddModalOpen, setIsAddModalOpen] = useState(false)
	const [currentPage, setCurrentPage] = useState(0)

	const getBusinessPartners = useCallback(
		async (client) => {
			setIsLoading(true)
			api
				.get(`BusinessPartners`, {
					params: {
						$select: 'CardName, CardCode, U_Telephone, U_pinfl, U_PS',
						$filter: `contains(CardName, '${client || ''}') or contains(U_Telephone, '${client || ''}') or contains(CardCode, '${client || ''}') and GroupCode eq 102`,
						$skip: currentPage * 20,
					},
					headers: { Prefer: 'odata.maxpagesize=20' },
				})
				.then((res) => {
					setData(JSON.parse(res.data).value || [])
					console.log(
						'JSON.parse(res.data).value || []',
						JSON.parse(res.data).value || [],
					)

					setIsLoading(false)
				})
				.catch((err) => {
					if (isAxiosError(err)) errorRef.current?.open(get(err, 'message', ''))
					setIsLoading(false)
				})
		},
		[currentPage],
	)

	useEffect(() => {
		getBusinessPartners()
	}, [getBusinessPartners])

	return (
		<Layout>
			<AllProductsStyle style={{ backgroundColor: BG_COLOR }}>
				<div className="container">
					<p className="productTitle">Черный список</p>
					<div className="flex items-end justify-betweens my-8">
						<div className="flex items-end gap-4 flex-wrap">
							<div className="flex flex-col gap-1">
								<p className="text-sm font-medium">Клиент</p>
								<div className="relative">
									<input
										className={
											'border-[1px] border-[#d9d9d9] p-2 rounded-md min-w-[250px]'
										}
										type="text"
										placeholder="Клиент"
										value={searchValue}
										onChange={(e) => {
											setSearchValue(e.target.value)
										}}
									/>
								</div>
							</div>

							<Button
								className="!h-10"
								onClick={() => {
									setCurrentPage(0)
									getBusinessPartners(searchValue)
								}}
								isLoading={isLoading}
							>
								Поиск
							</Button>
							<Button
								className="!h-10"
								onClick={() => setIsAddModalOpen(true)}
								isLoading={isLoading}
							>
								Добавить
							</Button>
						</div>
					</div>

					{isLoading ? (
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<>
							<div className="overflow-y-auto mb-8">
								<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
									<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
										<tr>
											<th scope="col" className="px-6 py-4">
												Имя Клиента
											</th>
											<th scope="col" className="px-6 py-4">
												ПИНФЛ
											</th>
											<th scope="col" className="px-6 py-4">
												Пасспорт серия
											</th>
											<th scope="col" className="px-6 py-4">
												Телефон
											</th>
										</tr>
									</thead>
									<tbody>
										{data.map((v, i) => {
											return (
												<tr
													key={i}
													onClick={() => {}}
													className="bg-white border-b  hover:bg-gray-50 "
												>
													<td className="px-6 py-4">
														{get(v, 'CardName', '-')}
													</td>
													<td className="px-6 py-4">
														{get(v, 'CardCode', '-')}
													</td>
													<td className="px-6 py-4">{get(v, 'U_PS', '-')}</td>
													<td className="px-6 py-4">
														{get(v, 'U_Telephone', '-')}
													</td>
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>
							<div className="topCard">
								<div className="flex items-center gap-2 ">
									<Button
										disabled={currentPage === 0}
										className={'btn'}
										onClick={() => setCurrentPage((prev) => prev - 1)}
									>
										{'<'}
									</Button>
									<p>{currentPage + 1}</p>
									<Button
										disabled={data.length < 20}
										className={'btn'}
										onClick={() => setCurrentPage((prev) => prev + 1)}
									>
										{'>'}
									</Button>
								</div>
							</div>
						</>
					)}
				</div>
			</AllProductsStyle>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
			{isAddModalOpen && (
				<CreateBlackListUser
					isOpen={isAddModalOpen}
					onClose={() => setIsAddModalOpen(false)}
				/>
			)}
		</Layout>
	)
}
